import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wlm-grid-header-buttons',
    templateUrl: './grid-header-buttons.component.html',
    styleUrls: ['./grid-header-buttons.component.scss'],
    standalone: false
})
export class GridHeaderButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
